import './scss/Mobile.scss';
import './scss/Desktop.scss';
import Header from './components/Header.js';
import Body from './components/Body.js';
import ArtistPage from './components/ArtistPage';
import { useState } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

function App() {
  return (
    <Router>
      <div className="App">
        <Switch>
          <Route path="/artist">
            <Header />
            <ArtistPage />
          </Route>
          <Route path="/">
            <Header />
            <Body />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
